import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { isE2eBypassEnabled } from './e2e-bypass';

/**
 * Route guard that delegates to {@link MsalGuard} during normal operation but
 * grants access immediately when the e2e auth bypass is active. This keeps the
 * real Azure AD login flow untouched in production while letting Playwright
 * feature tests run without an interactive login.
 */
@Injectable({ providedIn: 'root' })
export class AppAuthGuard implements CanActivate, CanActivateChild {
  constructor(private readonly msalGuard: MsalGuard) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (isE2eBypassEnabled()) {
      return true;
    }
    return this.msalGuard.canActivate(route, state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (isE2eBypassEnabled()) {
      return true;
    }
    return this.msalGuard.canActivateChild(route, state);
  }
}
